export default __webpack_public_path__ + "static/media/Replit.6ce08356.svg";